import axios from "axios";

export async function getDraftMaintenanceCollectionByUser(token:string, params:any): Promise<any> {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_URL+`/manutencao/coleta/rascunho`, {
        params,
        headers: {
            Authorization: 'Bearer ' + token
        }
        });
  
      return response.data; // Supondo que as requisições sejam retornados pelo backend
    } catch (error) {
      throw new Error('Falha na autenticação');
    }
}

export async function getProcessMaintenanceCollectionByUser(token:string, params:any): Promise<any> {
  try {
    const response = await axios.get(process.env.REACT_APP_BASE_URL+`/manutencao/coleta/processadas`, {
      params,
      headers: {
          Authorization: 'Bearer ' + token
      }
      });

    return response.data; // Supondo que as requisições sejam retornados pelo backend
  } catch (error) {
    throw new Error('Falha na autenticação');
  }
}